import { StoryElementType } from 'webapp/enums/enums';

import StoryElementBase from 'webapp/models-custom/story-element/base';

export default class StoryElementCompareValue extends StoryElementBase {
	type = StoryElementType.COMPARE_VALUE;

	override get isLoading(): boolean {
		return super.isLoading || !this.dataRoot;
	}

	get longTitle(): string {
		let text = this.shortTitle;

		const compare = this.compare;
		if (!compare?.isGoal) {
			text += ' value';
		}

		return text;
	}

	override get shortTitle(): string {
		const compare = this.compare;
		if (compare?.isGoal) {
			return 'Goal value';
		}
		return 'Comparison';
	}

	openEdit(_node: HTMLElement): void {
		this.openAdvanced();
	}

	fillElementContent(node: HTMLElement): void {
		node.classList.toggle('loading', this.isDataIncomplete);

		const text = this.comparePoint?.valueStr || '-';
		node.textContent = text;
	}
}
